
export const isProduction = ( process.env.VERCEL_ENV || process.env.NEXT_PUBLIC_VERCEL_ENV ) === 'production';

export const domain = `https://${!isProduction && 'dev.' || ''}invoiss.com`;
